import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const { data } = await api.post(
          "/auth/session",
          { session_id: sessionId },
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-6">
      <img src={LOGO_URL} alt="Assietica Suite" className="h-16 w-auto object-contain animate-pulse" />
      <div className="flex items-center gap-3 text-slate-500">
        <div className="h-4 w-4 rounded-full border-2 border-brand-blue border-t-transparent animate-spin" />
        <span>Accesso in corso…</span>
      </div>
    </div>
  );
}
